import { useBrandedAppQueryStore } from '../stores/branded-app.query-store'

/**
 * Branded-app metadata (store links, package id, app icon) for a location.
 * Entry point for consumers; the query lives in the branded-app query store.
 */
export const useBrandedAppMetadata = () => {
  const { fetchBrandedAppMetadataQuery } = useBrandedAppQueryStore()

  return { fetchBrandedAppMetadataQuery }
}
